module.exports = __webpack_public_path__ + "img/anadolusem-logo-v.728d6e1c.svg";